import { DynamicFormFieldValidator } from '../dynamic-form-element-validator.model';
import { DynamicFormElementValidatorConfig } from '../dynamic-form-element-validator-config.model';
import { DynamicFormElementValidatorType } from '../dynamic-form-element-validator-type.enum';
import { Validators } from '@angular/forms';

export class MaxValueValidator extends DynamicFormFieldValidator {

  defaultErrorMsg = 'La valeur maximale pour ce champ est de {{value}}.';

  constructor(config: DynamicFormElementValidatorConfig) {
    super(config);
    this.setType(DynamicFormElementValidatorType.MAX_VALUE);
    this.setValue(config.value);
    this.configureError(config);
    this.setValidatorFn(Validators.max(this.value));
  }

  configureError(config: DynamicFormElementValidatorConfig) {
    this.errorMsg = config.errorMsg ?? this.defaultErrorMsg;
    this.interpolateValueInErrorMessage(this.value);
    this.errorKey = 'max';
  }

}
